import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export const CTASection = ({ onRequestDemo }) => {
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.3 });

  return (
    <section
      className="py-24 px-[5%] border-t border-[#1e1e1e] relative overflow-hidden"
      data-testid="cta-section"
    >
      <div className="absolute inset-0 opacity-[0.03]">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern
              id="grid"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M 40 0 L 0 0 0 40"
                fill="none"
                stroke="#ffffff"
                strokeWidth="0.5"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div 
        ref={contentRef}
        className="max-w-content mx-auto relative z-10 text-center"
      >
        <h2 
          className="text-[clamp(2rem,4vw,3rem)] font-medium tracking-[-0.5px] leading-[1.2] text-white mb-4"
          style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.7s ease-out, transform 0.7s ease-out",
          }}
        >
          See what Veranda finds in your market.
        </h2>
        <p 
          className="text-[1rem] text-[#9ca3af] mb-8"
          style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.7s ease-out 0.1s, transform 0.7s ease-out 0.1s",
          }}
        >
          Pick a market. We'll show you what's there.
        </p>
        <div
          style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)",
            transition: "opacity 0.7s ease-out 0.2s, transform 0.7s ease-out 0.2s",
          }}
        >
          <Button
            onClick={onRequestDemo}
            className="bg-[#3b82f6] hover:bg-[#2563eb] text-white font-semibold text-[0.95rem] rounded-[8px] px-6 py-3 transition-all duration-200 hover:-translate-y-[1px] shadow-glow hover:shadow-glow-hover"
            data-testid="cta-btn"
          >
            Let's talk <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};
